export default __webpack_public_path__ + "static/media/discounts-6off25-image.f8ac1285.svg";